import { render, staticRenderFns } from "./AddEditGroupCertificate.vue?vue&type=template&id=853fae8a"
import script from "./AddEditGroupCertificate.vue?vue&type=script&lang=js"
export * from "./AddEditGroupCertificate.vue?vue&type=script&lang=js"
import style0 from "./AddEditGroupCertificate.vue?vue&type=style&index=0&id=853fae8a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports